module.exports = __webpack_public_path__ + "img/topic.345b15d1.png";